<div class="{{squareMode ? 'square-mode' : ''}}">
  <a [routerLink]="!disabled ? link : null" [class]="'link ' + color + ' ' +  (disabled ? 'link-disabled':'')"
    (click)="doClick()" [appTooltip]="tooltip ? tooltip : null">
    <div class="text-icon">
      <mat-icon class="icon">{{icon}}</mat-icon>
      <div *ngIf="text" class="text">
        <span>{{text}}</span>
        <span *ngIf="text2">{{text2}}</span>
      </div>
    </div>
    <div *ngIf="showKpi" class="kpi">
      <span>{{ kpiToShow }}</span>
    </div>
  </a>
</div>